import { render, staticRenderFns } from "./AdminMessageDetail.vue?vue&type=template&id=efc776e0&scoped=true"
import script from "./AdminMessageDetail.vue?vue&type=script&lang=js"
export * from "./AdminMessageDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/all_messages.css?vue&type=style&index=0&id=efc776e0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc776e0",
  null
  
)

export default component.exports